
import IndexModel from "@/service/v1/sigap/IndexModel";
 
class InstrutorService extends IndexModel { 
       
    constructor() {
        super();
        this.url =  this.url + '/Instrutor' ;  
    }
 
    public getApiUrl(  ) { 
        return this.getAxios().defaults.baseURL + this.url; 
    }
 
    public getModel( id  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/' + id    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
 
    public getAll( search:any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '?' + search    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
 
    public getEscolaridades(  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url +  '/GetTipoEscolaridade'  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
     
    public getTipoPagamento(  ) : Promise<any> {
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url +  '/GetTipoPagamento'  )
            .then(response => {
                resolve( response.data);
            })
            .catch(error => {
                reject(error.response);
            })
        });
    }

    public getTipo(  ) : Promise<any> {
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url +  '/GetTipo'  )
            .then(response => {
                resolve( response.data);
            })
            .catch(error => {
                reject(error.response);
            })
        });
    }
  
    public alterarPagamento( id: any  ) : Promise<any>  { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().put( this.url + '/Dados/Pagamento' , {id :id } )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
 
    
    public vincular( id: any  ) : Promise<any>  { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().put( `${this.url}/${id}/Vincular` , {} )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
 

    
    public desvincular( id: any  ) : Promise<any>  {
        return  new Promise((resolve, reject) => {
            this.getAxios().put( `${this.url}/${id}/Desvincular` , {} )
            .then(response => {
                resolve( response.data);
            })
            .catch(error => {
                reject(error.response);
            })
        });
    }


    public alternarTipo( id: any  ) : Promise<any>  {
        return  new Promise((resolve, reject) => {
            this.getAxios().put( `${this.url}/${id}/AlternarTipo` , {} )
            .then(response => {
                resolve( response.data);
            })
            .catch(error => {
                reject(error.response);
            })
        });
    }
 







    public getStatus( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/GetStatus'   , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }



  
    public getResource( id  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/resource/' + id    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
   
    public getAlunosAdicionarNota(  id  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/' + id + '/alunos')
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
  
    public homologarAula( instrutor , aula  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().post( this.url + '/' + instrutor + '/aula/' + aula+ '/homologar' , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
  
    public cadastrarNota( id: any ,   dados: any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().post( this.url + '/' + id + '/notas'  , dados   )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
  
    public excluirNota( instrutor:any , nota: any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().delete( this.url + '/' + instrutor + '/notas/' + nota    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
  
}
 

export default InstrutorService;

